
export const countryCodes: { label: string; value?: string; disabled?: boolean; }[] = [
  { value: 'gb', label: 'Great Britain (Default)' },
  { value: 'us', label: 'United States' },
  { value: 'fr', label: 'France' },
  { value: 'de', label: 'Germany' },
  { label: '------------------------', disabled: true },
  { value: 'ar', label: 'Argentina' },
  { value: 'au', label: 'Australia' },
  { value: 'at', label: 'Austria' },
  { value: 'by', label: 'Belarus' },
  { value: 'be', label: 'Belgium' },
  { value: 'bg', label: 'Bulgaria' },
  { value: 'bo', label: 'Bolivia' },
  { value: 'br', label: 'Brazil' },
  { value: 'ca', label: 'Canada' },
  { value: 'cl', label: 'Chile' },
  { value: 'cn', label: 'China' },
  { value: 'co', label: 'Colombia' },
  { value: 'hr', label: 'Croatia' },
  { value: 'cz', label: 'Czech Republic' },
  { value: 'dk', label: 'Denmark' },
  { value: 'ec', label: 'Ecuador' },
  { value: 'fi', label: 'Finland' },
  { value: 'gr', label: 'Greece' },
  { value: 'hu', label: 'Hungary' },
  { value: 'in', label: 'India' },
  { value: 'ie', label: 'Ireland' },
  { value: 'it', label: 'Italy' },
  { value: 'jp', label: 'Japan' },
  { value: 'lv', label: 'Latvia' },
  { value: 'lt', label: 'Lithuania' },
  { value: 'my', label: 'Malaysia' },
  { value: 'mx', label: 'Mexico' },
  { value: 'nl', label: 'Netherlands' },
  { value: 'nz', label: 'New Zealand' },
  { value: 'no', label: 'Norway' },
  { value: 'pe', label: 'Peru' },
  { value: 'ph', label: 'Philippines' },
  { value: 'pl', label: 'Poland' },
  { value: 'pt', label: 'Portugal' },
  { value: 'ee', label: 'Estonia' },
  { value: 'kr', label: 'South Korea' },
  { value: 'vn', label: 'Vietnam' },
  { value: 'th', label: 'Thailand' },
  { value: 'ru', label: 'Russia' },
  { value: 'sg', label: 'Singapore' },
  { value: 'es', label: 'Spain' },
  { value: 'se', label: 'Sweden' },
  { value: 'ch', label: 'Switzerland' },
  { value: 'th', label: 'Thailand' },
  { value: 'tr', label: 'Turkey' },
  { value: 'ae', label: 'United Arab Emirates' },
  { value: 'ua', label: 'Ukraine' },
  { value: 'vn', label: 'Vietnam' },
]
